export const GET_MODAL_STATUS = "getModalStatus";
export const GET_CURRENT_RECIPE_ID = "getCurrentRecipeId";
